import { render } from "./PrSupportChatRules.vue?vue&type=template&id=4d7a9b06&scoped=true"
import script from "./PrSupportChatRules.vue?vue&type=script&lang=js"
export * from "./PrSupportChatRules.vue?vue&type=script&lang=js"

import "./PrSupportChatRules.vue?vue&type=style&index=0&id=4d7a9b06&scoped=true&lang=css"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7a9b06"]])

export default __exports__